var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemsGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5H20.5M21 5.96126V17C21 19.2092 19.2091 21 17 21H5C2.79086 21 1 19.2092 1 17V5.96126C1 5.35369 1.27618 4.77907 1.75061 4.39953L4.90434 1.87653C5.6136 1.30912 6.49484 1 7.40313 1L14.5969 1.00001C15.5052 1.00001 16.3864 1.30914 17.0957 1.87654L20.2494 4.39953C20.7238 4.77907 21 5.3537 21 5.96126ZM8 5H14V8C14 9.65685 12.6569 11 11 11C9.34315 11 8 9.65685 8 8V5Z",
    stroke: "#3C7795",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemsGlobal);
export default __webpack_public_path__ + "static/media/itemsGlobal.45f15278026dded3b76317724e5e78e8.svg";
export { ForwardRef as ReactComponent };